import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=5293312b&scoped=true&"
import script from "./uploadImage.vue?vue&type=script&lang=js&"
export * from "./uploadImage.vue?vue&type=script&lang=js&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=5293312b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293312b",
  null
  
)

export default component.exports